export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      functionName: "見守り機能",
      locationNumber: "location-00001",
      nickName: "アイラ１号",
      answeredAt: 1234567890123,
      answer: "相談したい",
      responseStatus: 0,
      responseNote: "note test"
    }
  }
}